// Заголовок полноширинного раздела: где я, что здесь и когда сняты данные.
//
// Заведён 27.08.2026, когда осмотр экранов показал, что одну и ту же вещь два раздела рисуют
// по-своему: «Дела» — белая полоса с рамкой и отступами 20 по горизонтали, «Настройки» — просто
// текст на сером фоне без рамки и без разделителя. На одном экране разница не видна, а при
// переходе между разделами верх страницы то есть, то его нет.
//
// Это НЕ `toolbar`: та шапка про отборы и действия над представлением, здесь же только
// название раздела и срез данных. Разделы, у которых есть и то и другое, ставят обе подряд.

import type { ReactNode } from 'react';

import { cn } from '@/utils/cn';

export interface SectionHeaderProps {
  /** Название раздела: где человек находится. */
  title: string;
  /** Что здесь происходит, одной строкой. Пусто, пока данные не приехали. */
  subtitle?: ReactNode;
  /** Правый край: срез данных, счётчик, редкое действие. */
  aside?: ReactNode;
  className?: string;
}

export function SectionHeader({ title, subtitle, aside, className }: SectionHeaderProps) {
  return (
    <header
      className={cn(
        // По базовой линии: справа стоит мелкий срез данных, и по центру он висел бы выше
        // подписи раздела.
        'flex shrink-0 items-baseline justify-between gap-3',
        'border-b border-stroke-soft-200 bg-bg-white-0 px-5 py-3',
        // В узком окне поле у всех поверхностей одно — 16 точек: заголовок раздела стоит в
        // той же колонке, что список и шапка отборов под ним.
        'узко:px-4',
        className,
      )}
    >
      <div className='flex min-w-0 flex-col'>
        <h1 className='text-label-lg text-text-strong-950'>{title}</h1>
        {subtitle !== undefined && subtitle !== null && (
          <p className='text-paragraph-sm text-text-sub-600'>{subtitle}</p>
        )}
      </div>
      {aside !== undefined && aside !== null && (
        <span className='shrink-0 text-paragraph-xs text-text-soft-400'>{aside}</span>
      )}
    </header>
  );
}
